import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

export const sxStyles = {
  divider: (theme: Theme) => ({
    margin: '0 1.5rem',
    height: '2rem',
    borderRight: `1px solid ${theme.palette.divider}`,
  }),
  flexPosition: {
    display: 'flex',
    alignItems: 'center',
  },
  cipCode: (theme: Theme) => ({
    marginLeft: '0.5rem',
    color: theme.palette.grey['600'],
  }),
};

export const StyledCardWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  maxWidth: '1280px',
  width: '100%',
  minHeight: '80px',
  padding: '1rem',
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderBottomRightRadius: '8px',
  borderTopRightRadius: '8px',
  borderLeft: `4px solid ${theme.palette.primary.main}`,

  [theme.breakpoints.up('sm')]: {
    padding: '1rem 2rem 1.5rem',
  },
}));

export const StyledCardIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',

  '& > svg:first-of-type': {
    fill: theme.palette.primary.main,
  },

  [theme.breakpoints.up('md')]: {
    overflow: 'visible',
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
}));

export const StyledTitlesWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'start',

    '& > p:last-of-type': {
      margin: 0,
    },
  },
}));

export const StyledMajorTitle = styled(CoreTypography)(({ theme }) => ({
  fontSize: '1rem',

  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
}));

export const StyledMoreBtn = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.5rem',
  maxWidth: '40px',
  width: '100%',
  color: theme.palette.primary.main,
  fontWeight: 600,

  '& > svg:first-of-type': {
    margin: 0,
    fill: theme.palette.primary.main,
  },

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '110px',
    padding: '0.5rem 1rem',

    '& > svg:first-of-type': {
      marginLeft: '1rem',
    },
  },
}));
